<template>
  <teleport to="#toast">
    <transition name="toast">
      <div
        v-if="show"
        class="c-toast"
        :style="{
        }"
      >
        <c-icon
          v-if="type === 'error' || type === 'success'"
          :type="icon"
          :color="iconColor"
          :style="{ marginRight: '.6rem' }"
        />
        {{ message }}
      </div>
    </transition>
  </teleport>
</template>

<script>
import CIcon from 'shared/components/CIcon.vue';

export default {
  name: 'CToast',
  components: { CIcon },
  data() {
    return { message: '', show: false, type: 'default' };
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'error':
          return 'warning';
        case 'success':
          return 'check-mark-circle-filled';
        default:
          return '';
      }
    },
    iconColor() {
      switch (this.type) {
        case 'error':
          return this.$colors.yellow.base;
        case 'success':
          return this.$colors.green.base;
        default:
          return '';
      }
    },
  },
  methods: {
    showToast(payload) {
      this.message = payload.message;
      this.type = payload.type;
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
  created() {
    this.$eventBus.addEventListener('show-toast', this.showToast);
  },
  beforeUnmount() {
    this.$eventBus.removeEventListener('show-toast');
  },
};
</script>
<style scoped lang="scss" type="text/scss">
@import "shared/assets/scss/box-shadow";

.c-toast {
  background: map_get($grey, 'darken-4');
  color: white;
  position: fixed;
  display: flex;
  align-items: center;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
  padding: .6rem 1.6rem;
  border-radius: .3rem;

  @include box_shadow(1);

  animation: slide-up .2s ease-in-out;

  @keyframes slide-up {
    0% {
      top: -2rem
    }

    100% {
      top: 2rem;
    }
  }
}
</style>
